export { default } from './SimpleCarousel';
